import React from 'react';
import { Circle } from 'lucide-react';

export function PageFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <div className="page-footer">
      <div className="page-footer-main">
        <div className="page-footer-brand">
          <span className="text-gradient-accent font-semibold">
            Team Selection
          </span>
          <span>© {currentYear}</span>
        </div>

        <div className="page-footer-tagline">
          <div className="flex items-center gap-1">
            <Circle size={16} fill="currentColor" />
            <span>Build balanced teams effortlessly</span>
          </div>

          <div className="separator-vertical" />

          <div className="page-footer-version">
            v1.0.0
          </div>
        </div>
      </div>

      <div className="page-footer-bottom">
        <span>Made with passion for fair team selection</span>
        <span>•</span>
        <a
          href="mailto:support@teamselection.co.uk"
          className="page-footer-link"
        >
          support@teamselection.co.uk
        </a>
      </div>
    </div>
  );
}
